import { el } from "date-fns/locale";
import { GET_GUEST_TOKEN } from "../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";

export const getGuestToken =
  (setLoading, dashboardid, dataset, from) => async (dispatch) => {
    try {
      setLoading(true);

      const response = await determineBaseUrlAndPerformApiCall(
        `${GET_GUEST_TOKEN}?dashboardid=${dashboardid}&dataset=${dataset}`,
        "GET"
      );

      if (response && response?.guestToken) {
        if (from === "step") {
          localStorage.setItem("stepGuestToken", response.guestToken);
          return response.guestToken;
        } else if (from === "inventory") {
          localStorage.setItem("inventoryGuestToken", response.guestToken);
          return response.guestToken;
        } else if (from === "ems") {
          localStorage.setItem("emsGuestToken", response.guestToken);
          return response.guestToken;
        } else {
          localStorage.setItem("guestToken", response.guestToken);
          return response.guestToken;
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
